<template>
<el-dialog :visible.sync="dialogVisible" :before-close="closeModal" width="650px">
    <div class="row d-flex justify-content-center align-items-center mt-5">
        <div class="col-12 text-center">
            <component v-bind:is="icon"></component>
        </div>
        <div class="col-12 text-center mt-2">
            <h3 class="c-ndarkthree bold mb-2" v-html="subtitle">
            </h3>
            <p class="c-ndarkfour regular" v-html="text">
            </p>
        </div>
        <el-form class="col d-flex justify-content-center mt-5" :model="requestInfo" ref="requestInfo" :rules="rules">
            <div class="col-5">
                <el-form-item prop="amount">
                    <label for="">Valor solicitado</label>
                    <Money v-model="value" class="input-money" v-bind="money"></Money>
                </el-form-item>
            </div>
            <div class="col-5">
                <el-form-item prop="portionAmount">
                    <label for="">Valor da parcela</label>
                    <Money v-model="requestInfo.portionAmount" class="input-money" v-bind="money" @change.native="validateForm" />
                </el-form-item>
            </div>
        </el-form>
    </div>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">

        <router-link :class="`${getPrimaryColor} mr-4 c-ndarkfour`" to="" @click.native="closeModal">
            Cancelar
        </router-link>
        <Button @click="request" :disabled="!formValid" :color="getPrimaryColor">
            Solicitar
        </Button>

    </span>
</el-dialog>
</template>

<script>
import {
    Money
} from 'v-money'
import RequestFinancing from '@/components/icons/RequestFinancing.vue'
import Contracts from '@/components/icons/Contracts.vue'
import insertContractsProjects from '@/api/insertContractsProjects'
import insertWorkingCapital from '@/api/insertWorkingCapital'
export default {
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false,
        },
        value: {
            default: ''
        },
        title: {
            default: ''
        }

    },
    computed: {
        valueC() {
            let valor = this.value.substr(3);
            valor = parseFloat(valor).toFixed(2)
            return valor
        },
        subtitle() {
            return (this.title == 'Capital de giro')
                ? 'Financiamento para capital de giro'
                : 'Financiamento para contratos e projetos'
        },
        text() {
            return (this.title != 'Capital de giro')
                ? `Você está a um passo de obter o capital necessário para seus <span class="bold">contratos e projetos!</span> Basta inserir o valor total do financiamento e quanto deseja pagar por mês.`
                : `Você está a um passo de obter o <span class="bold">capital de giro</span> necessário para sua empresa! Basta inserir o valor total do financiamento e quanto deseja pagar por mês.`;
        },
        icon() {
            return (this.title != 'Capital de giro') ? 'Contracts' : 'RequestFinancing'
        },
    },
    data() {
        return {
            requestInfo: {
                amount: this.value,
                portionAmount: ''
            },
            rules: {
                portionAmount: [{
                    required: true,
                    message: '',
                    trigger: 'change'
                }, ]
            },
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2,
            },
            formValid: false,
        }
    },
    components: {
        RequestFinancing,
        Contracts,
        Money
    },
    methods: {
        validateForm() {
            this.$refs['requestInfo'].validate((valid) => {
                if (valid) {
                    console.log(parseFloat(this.requestInfo.portionAmount) < parseFloat(this.value))
                    if (parseFloat(this.requestInfo.portionAmount) <= parseFloat(this.value)) this.formValid = true
                    if (parseFloat(this.requestInfo.portionAmount) > parseFloat(this.value)) this.formValid = false

                } else {
                    this.formValid = false
                }
            });
        },
        closeModal() {
            this.$emit('closeModal', false)
        },
        handleRequestButton() {
            this.$emit('request')
        },
        request() {
            const { cnpjId, companys } = this.$store.state.user
            const { tradingName } = companys.find(company => company.cnpj.id === cnpjId)

            let valor = ({
                "value": this.value,
                "valuePortion": this.requestInfo.portionAmount,
                "tradingName": tradingName
            })
            
            if (this.title != 'Capital de giro') {
                insertContractsProjects(valor)
            } else {
                insertWorkingCapital(valor)
            }
            this.$emit('request')

        }
    }
}
</script>

<style>

</style>
